import { ChangeDetectionStrategy, Component } from '@angular/core';
import { InsertionPointWorkflowComponent, OsteotomyWorkflowComponent } from '../correction';
import { TemplateSelectionComponent } from '../product';
import { BaseComponent } from '../shared';
import { ViewerComponent } from '../viewer';
import { DrawerComponent } from './drawer';
import { ToolsMenuComponent } from './tools-menu';


/**
 * First left vertical bar.
 */
@Component({
	selector: 'sidebar',
	templateUrl: './sidebar.component.html',
	imports: [
		DrawerComponent,
		ViewerComponent,
		ToolsMenuComponent,
		TemplateSelectionComponent,
		OsteotomyWorkflowComponent,
		InsertionPointWorkflowComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class SidebarComponent extends BaseComponent { }
